<div *ngIf="isMobile">
  <h5 class="mobile-nav-title mb-2" i18n>Convert Lead To Quote</h5>
  <div class="mb-5 mx-3">
    <p i18n>Please confirm lead information to generate new quote.</p>
    <app-project-info-mobile projectType="convert" [quote]="lead"></app-project-info-mobile>
  </div>
</div>

<div *ngIf="!isMobile">
  <div class="container-fluid">
    <app-header titleText="QUOTES" i18n-titleText progressBarState="quote"></app-header>

    <div class="card bg-light">
      <div class="card-header">
        <img src="assets/img/circle_images/quotes_circle.png" alt="Customer Icon" class="card-icon" />
        <span i18n>Convert Lead to Quote</span>
        <p i18n>Please confirm lead information to generate new quote.</p>
      </div>
      <div class="card-body">
        <app-project-info projectType="convert" [quote]="lead"></app-project-info>
      </div>
    </div>
  </div>
</div>
